import { ClientOnly } from '@/components/ClientOnly'
import { FullScreenLoading } from '@/components/FullScreenLoading'
import { WebFooter } from '@/components/web-footer'
import { SchoolWebTopHeader } from '@/components/web-top-header/SchoolWebTopHeader'
import { SchoolLayout } from '../school'
import { SchoolAdminForcePasswordChangeGuard } from './school/SchoolAdminForcePasswordChangeGuard'

interface Props {
  children: React.ReactNode
}

export const EnterpriseDetailLayout = ({ children }: Props): JSX.Element => {
  return (
    <SchoolLayout>
      <SchoolAdminForcePasswordChangeGuard>
        <EnterpriseDetailLayoutInner>{children}</EnterpriseDetailLayoutInner>
      </SchoolAdminForcePasswordChangeGuard>
    </SchoolLayout>
  )
}

function EnterpriseDetailLayoutInner(props: Props) {
  return (
    <div className="grid-areas-enterprise-detail-layout">
      <SchoolWebTopHeader className="grid-area-header" />
      <article className="grid-area-content bg-basic-bg">
        {props.children}
      </article>
      <WebFooter className="grid-area-footer" />
    </div>
  )
}

export function getEnterpriseDetailLayout(page: React.ReactElement) {
  return (
    <ClientOnly fallback={<FullScreenLoading />}>
      <EnterpriseDetailLayout>{page}</EnterpriseDetailLayout>
    </ClientOnly>
  )
}
